import styled from 'styled-components';
import ModalFooter from "../BaseModalComponents/Footer/ModalFooter";

export const Container = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 20px;
`

export const ModalBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > div {
    width: 80%;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
  }
`

export const Input = styled.input`
  height: 30px;
  width: 92%;
  overflow: hidden;
  margin: 18px;
  padding: 10px 12px;
  resize: none;
  outline: none;
  border: 2px solid rgba(98, 147, 97, 0.15);
  border-radius: 6px;
  font-size: 14px;
`
